import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {quotaIsFull} from '../../../utils/adAccountQuota';
import {FREE_UP_PATH, quotaFullTitle, recordQuotaEvent, requestMoreAccounts} from './accountQuota';
import './QuickConnectAccountModal.scss';

/**
 * El cupo de cuentas del plan está lleno (UD-15): lo dice ANTES de que se elija una cuenta que el alta
 * va a rechazar, con las dos salidas. Con cupo, o sin saberlo, no dibuja nada.
 *
 * «Liberar una cuenta» abre Conexiones › Cuentas en otra pestaña, como las salidas del vacío de
 * Vincular cuenta (UD-9): quien vuelve al modal lo encuentra recargado (el modal escucha el foco).
 */
export function AccountQuotaNotice({quota, surface}) {
    const {t} = useTranslation();
    const full = quotaIsFull(quota);

    useEffect(() => {
        if (full) recordQuotaEvent('shown', surface);
    }, [full, surface]);

    if (!full) return null;

    return (
        <div className="link-account-state" data-testid="account-quota-full">
            <h4>{quotaFullTitle(t, quota)}</h4>
            <p>{t('account_quota.full_text')}</p>
            <div className="link-account-state__actions">
                <a className="btn -alt" href={FREE_UP_PATH} target="_blank" rel="noopener noreferrer"
                   onClick={() => recordQuotaEvent('click_free', surface)}>
                    {t('account_quota.free_up')}
                </a>
                <button type="button" className="btn -negative"
                        onClick={() => requestMoreAccounts(t, quota, surface)}>
                    {t('account_quota.request')}
                </button>
            </div>
        </div>
    );
}
